<template>
  <div>
    <el-card class="box-card">
      <el-form :model="customerChange" ref="customerChangeRef" label-width="82px">
        <el-form-item label="登录名" class="addAdminForm">
          <el-input v-model="customerChange.newloginname" placeholder=""></el-input>
        </el-form-item>
        <el-form-item class="mt20">
            <el-button type="primary" @click="clicksave">保存</el-button>
            <el-button type="info" @click="backCustomerManagement">返回</el-button>
        </el-form-item>
      </el-form>

      <div class="title mt20">登录名修改记录</div>
      <el-table :data="listlog" border stripe class="mt15">
        <el-table-column prop="Oldloginname" label="旧登录名"></el-table-column>
        <el-table-column prop="Newloginname" label="新登录名"></el-table-column>
        <el-table-column prop="Adminname" label="操作人员"></el-table-column>
        <el-table-column prop="Createtime" label="操作时间"></el-table-column>
      </el-table>

    </el-card>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  data () {
    return {
      customerChange: {
        glassuserid: '0',
        oldloginname: '',
        newloginname: ''
      },
      listlog: []
    }
  },
  mounted () {

  },
  methods: {
    LoadData (row) {
      this.customerChange.glassuserid = row.Id
      this.customerChange.oldloginname = row.Loginname
      this.customerChange.newloginname = row.Loginname
      this.apiGetcustomerchangeuserlogin()
    },
    backCustomerManagement () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.apiEditCustomerLoginName()
    },
    apiGetcustomerchangeuserlogin: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.customerChange.glassuserid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getcustomerchangeuserlogin, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.listlog = response.data.List
          }
          console.log(response.data)
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditCustomerLoginName: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.customerChange.glassuserid,
        oldloginname: that.customerChange.oldloginname,
        newloginname: that.customerChange.newloginname
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditCustomerLoginName, Qs.stringify(data))
        .then(function (response) {
          that.apiGetcustomerchangeuserlogin()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.speed {
    width: 440px;
    margin-right: 15px;
}
</style>
